import { useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function SKUImage({ images }) {
  const { skuImages, setSKUImages, newImages, setNewImages, isEdit } = images ?? {};
  const [errorMessage, setErrorMessage] = useState("");

  const onFileChange = (file) => {
    if (isEdit === true) {
      const imageLength = skuImages.filter((x) => x.active === true).length;
      if (file.length + newImages.length + imageLength > 5) {
        document.getElementById("files").value = null;
        setErrorMessage("One SKU can have 5 image only");
        return;
      }
    } else {
      if (file.length + newImages.length > 5) {
        document.getElementById("files").value = null;
        setErrorMessage("Maximum can have 5 image only");
        return;
      }
    }

    let isImageSizeValid = true;
    let isImageFormatValid = true;

    let fileArray = [];

    for (let i = 0; i < file.length; i++) {
      fileArray.push(file[i]);
    }

    fileArray.forEach((x) => {
      if (x.size > 1 * 1024 * 1024) {
        isImageSizeValid = false;
      }
      const fileName = x.name;
      const fileExtension = fileName.split(".")[1];
      if (!["jpeg", "png"].includes(fileExtension)) {
        isImageFormatValid = false;
      }
      //console.log(fileName)
    });

    if (!isImageSizeValid) {
      document.getElementById("files").value = null;
      setErrorMessage("Image size must less than 1 mb");
      return;
    }

    if (!isImageFormatValid) {
      document.getElementById("files").value = null;
      setErrorMessage("Invalid image format must be png/jpeg");
      return;
    }

    let imageUrl = [];
    const defaults = isEdit === true ? [...newImages, ...skuImages] : [...newImages];
    const isDefault = defaults.some((x) => x.default);

    fileArray.forEach((x) => {
      let temp = URL.createObjectURL(x);
      let imageObj = {
        file: x,
        tempUrl: temp,
        default: false,
      };
      imageUrl.push(imageObj);
    });
    if (!isDefault) {
      imageUrl[0].default = true;
    }
    setNewImages([...imageUrl, ...newImages]);

    document.getElementById("files").value = null;
    setErrorMessage("");
  };
  const onDeleteNewImage = (index) => {
    let filterImage = newImages;
    filterImage.splice(index, 1);
    setNewImages([...filterImage]);
  };

  const onDefaultChange = (type, index) => {
    if (type === "NEW") {
      let filterNewImages = newImages.map((image, i) => {
        image.default = false;
        if (index === i) {
          image.default = true;
        }
        return image;
      });
      setNewImages(filterNewImages);
      if (isEdit === true) {
        let filterSavedImages = skuImages.map((image) => ({ ...image, default: false }));
        setSKUImages(filterSavedImages);
      }
    } else {
      let filterNewImages = newImages.map((image) => ({ ...image, default: false }));
      let filterSavedImages = skuImages.map((image, i) => {
        image.default = false;
        if (index === i) {
          image.default = true;
        }
        return image;
      });
      setNewImages(filterNewImages);
      setSKUImages(filterSavedImages);
    }
  };
  return (
    <MDBox>
      <MDBox mb={1}>
        <MDTypography pt={1} pb={1} color="info" variant="h5">
          Product Image (Maximum 5, image must less than 1 mb, png/jpeg only)
        </MDTypography>
        <input
          id="files"
          name="productImage"
          type="file"
          onChange={(e) => {
            onFileChange(e.target.files);
          }}
          multiple
        />
        <MDTypography
          color="error"
          sx={{ marginLeft: "12px", fontWeight: "bold" }}
          variant="button"
        >
          {errorMessage}
        </MDTypography>
      </MDBox>
      {newImages.length > 0 && (
        <MDBox MDBox marginBottom=".5rem">
          <MDTypography variant="h6">New Image (Preview)</MDTypography>
          <MDBox display="flex">
            {newImages.map((image, i) => (
              <MDBox
                key={i}
                sx={{
                  width: "300px",
                  height: "200px",
                  margin: 0.5,
                }}
              >
                <img style={{ width: "80%", height: "80%" }} src={image.tempUrl} />
                <MDButton
                  color="info"
                  variant={image.default ? "gradient" : "outlined"}
                  size="small"
                  onClick={() => {
                    onDefaultChange("NEW", i);
                  }}
                >
                  main
                </MDButton>
                <MDButton
                  sx={{ marginLeft: 1 }}
                  color="error"
                  variant="gradient"
                  size="small"
                  onClick={() => {
                    onDeleteNewImage(i);
                  }}
                >
                  delete
                </MDButton>
              </MDBox>
            ))}
          </MDBox>
        </MDBox>
      )}
      {isEdit && skuImages && skuImages.filter((x) => x.active === true).length > 0 && (
        <MDBox marginBottom=".5rem">
          <MDTypography variant="h6">Saved Image</MDTypography>
          <MDBox display="flex">
            {skuImages.map((image, i) => {
              if (image.active === true) {
                return (
                  <MDBox
                    key={i}
                    sx={{
                      width: "300px",
                      height: "200px",
                      margin: 1,
                    }}
                  >
                    <img style={{ width: "80%", height: "80%" }} src={image.imageUrl} />
                    <MDButton
                      color="info"
                      variant={image.default ? "gradient" : "outlined"}
                      size="small"
                      onClick={() => {
                        onDefaultChange("", i);
                      }}
                    >
                      main
                    </MDButton>
                    <MDButton
                      sx={{ marginLeft: 1 }}
                      color="error"
                      variant="gradient"
                      size="small"
                      onClick={() => {
                        skuImages[i].active = false;
                        setSKUImages([...skuImages]);
                      }}
                    >
                      delete
                    </MDButton>
                  </MDBox>
                );
              }
            })}
          </MDBox>
        </MDBox>
      )}
      {isEdit && skuImages && skuImages.filter((x) => x.active === false).length > 0 && (
        <MDBox>
          <MDTypography variant="h6">Deleted Image</MDTypography>
          <MDBox display="flex">
            {skuImages.map((image, i) => {
              if (image.active === false) {
                return (
                  <MDBox
                    key={i}
                    sx={{
                      width: "300px",
                      height: "200px",
                      margin: 1,
                    }}
                  >
                    <img style={{ width: "80%", height: "80%" }} src={image.imageUrl} />
                    <MDButton
                      color="success"
                      variant="gradient"
                      size="small"
                      onClick={() => {
                        const imageLength = skuImages.filter((x) => x.active === true).length;
                        if (newImages.length + imageLength >= 5) return;
                        skuImages[i].active = true;
                        setSKUImages([...skuImages]);
                      }}
                    >
                      restore
                    </MDButton>
                  </MDBox>
                );
              }
            })}
          </MDBox>
        </MDBox>
      )}
    </MDBox>
  );
}

export default SKUImage;
